<template>
  <v-container :fluid="true">
    <v-card v-if="isWordListReady && !editPage && !confirmPage" :flat="true">
      <v-card-title class="mb-3 text-h5 font-weight-bold">{{
        wordList.lbl_member_list
      }}</v-card-title>
      <v-card-text>
        <v-card :flat="true">
          <div
            v-if="$vuetify.display.xs"
            class="d-flex justify-end br_b_1 br_t_1 py-2 mb-5"
          >
            <v-btn variant="text" color="black" class="px-1" @click="onClickListSearch">
              絞り込み検索<v-icon>mdi-text-search</v-icon>
            </v-btn>
            <v-btn variant="text" color="black" class="pl-3 pr-0" @click="onClickListSetting">
              設定<v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
            <v-menu open-on-hover location="bottom">
              <template #activator="{ props }">
                <v-btn variant="text" color="black" v-bind="props" class="pl-3 pr-0">
                  アクション
                  <v-icon>mdi-cog</v-icon>
                </v-btn>
              </template>
              <v-list width="250" class="pl-5">
                <v-list-item-title
                  style="cursor: pointer"
                  @click="onClickCheckDelete"
                >
                  <v-icon class="mr-2">mdi-delete</v-icon>一括削除
                </v-list-item-title>
              </v-list>
            </v-menu>
          </div>
          <!-- 検索条件入力 { -->
          <v-expansion-panels v-else v-model="panel" :flat="true" :multiple="true" class="br_1">
            <v-expansion-panel>
              <v-expansion-panel-title
                class="py-0 font-weight-bold bk_gray_3"
                >{{ wordList.lbl_search }}</v-expansion-panel-title
              >
              <v-expansion-panel-text class="bk_gray_3 pt-0">
                <v-divider/>
                <Form v-slot="{ meta }">
                  <v-card class="bk_gray_3" :flat="true">
                    <v-card-text class="pt-9">
                      <v-row>
                        <!-- お名前(漢字・かな) -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field
                            v-slot="{ field, errors }"
                            :name="wordList.lbl_name_kanji_kana"
                            rules="max:100"
                          >
                            <v-text-field
                              :model-value="searchConditionName"
                              :label="wordList.lbl_name_kanji_kana"
                              bg-color="#fff"
                              density="compact"
                              variant="outlined"
                              clearable
                              :error-messages="errors"
                              @update:model-value="
                                (val) => {
                                  field.onChange(val);
                                  searchConditionName = val;
                                }
                              "
                              @blur="() => field.onBlur()"
                            ></v-text-field>
                          </Field>
                        </v-col>
                        <!-- 電話番号 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field
                            v-slot="{ field, errors }"
                            :name="wordList.lbl_tel"
                            rules="numeric|max:11"
                          >
                            <v-text-field
                              :model-value="searchConditionPhone"
                              :label="wordList.lbl_tel"
                              bg-color="#fff"
                              density="compact"
                              variant="outlined"
                              clearable
                              :error-messages="errors"
                              @update:model-value="
                                (val) => {
                                  field.onChange(val);
                                  searchConditionPhone = val;
                                }
                              "
                              @blur="() => field.onBlur()"
                            ></v-text-field>
                          </Field>
                        </v-col>
                        <!-- 郵便番号 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field
                            v-slot="{ field, errors }"
                            :name="wordList.lbl_zipcode"
                            rules="numeric|length:7"
                          >
                            <v-text-field
                              :model-value="searchConditionZipCode"
                              :label="wordList.lbl_zipcode"
                              bg-color="#fff"
                              density="compact"
                              variant="outlined"
                              clearable
                              :error-messages="errors"
                              @update:model-value="
                                (val) => {
                                  field.onChange(val);
                                  searchConditionZipCode = val;
                                }
                              "
                              @blur="() => field.onBlur()"
                            ></v-text-field>
                          </Field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <!-- ハウスカード番号 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field
                            v-slot="{ field, errors }"
                            :name="wordList.lbl_house_card"
                            rules="max:100"
                          >
                            <v-text-field
                              :model-value="searchConditionHouseCard"
                              :label="wordList.lbl_house_card"
                              bg-color="#fff"
                              density="compact"
                              variant="outlined"
                              clearable
                              :error-messages="errors"
                              @update:model-value="
                                (val) => {
                                  field.onChange(val);
                                  searchConditionHouseCard = val;
                                }
                              "
                              @blur="() => field.onBlur()"
                            ></v-text-field>
                          </Field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        variant="flat"
                        color="primary"
                        class="px-16 mt-6"
                        :disabled="!meta.valid"
                        @click="onClickSearch"
                        ><v-icon>mdi-magnify</v-icon
                        >{{ wordList.lbl_search }}</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </Form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- 検索条件入力 } -->
          <!-- 一覧表示  { -->
          <v-card :flat="true" width="100%">
            <v-data-table-server
              v-model="selectListCheckbox"
              item-value="memberId"
              :items-per-page="listOptions.itemsPerPage"
              :options="listOptions"
              :items="listDataArray"
              :items-length="listDataTotalCount"
              :loading="listLoading"
              :headers="filteredTableHeaders()"
              :no-data-text="wordList.lbl_no_data_text"
              show-select
              hide-default-footer
              :row-props="getRowProps"
              return-object
              :mobile="isXs"
              :hide-default-header="isXs"
              @update:options="(opts) => Object.assign(listOptions, opts)"
            >
              <template #top>
                <div class="d-flex justify-space-between mt-9 mb-5">
                  <div class="d-flex align-center flex-wrap">
                    <span class="pl-3">全 {{ listDataTotalCount }} 件 </span
                    ><span class="pl-1"> {{ displayPagingRangeText }} </span>
                    <v-pagination
                      v-model="listOptions.page"
                      :length="pageCount"
                      :total-visible="7"
                      variant="elevated"
                      density="comfortable"
                    >
                    </v-pagination>
                  </div>
                  <div v-if="!$vuetify.display.xs">
                    <v-btn
                      variant="text"
                      color="black"
                      class="px-2"
                      @click="onClickListSetting"
                    >
                      設定<v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                    <v-menu open-on-hover location="bottom">
                      <template #activator="{ props }">
                        <v-btn variant="text" color="black" v-bind="props" class="pr-0 pl-2">
                          アクション
                          <v-icon>mdi-cog</v-icon>
                        </v-btn>
                      </template>
                      <v-list width="250" class="pl-5">
                        <v-list-item-title
                          style="cursor: pointer"
                          @click="onClickCheckDelete"
                        >
                          <v-icon class="mr-2">mdi-delete</v-icon
                          >{{ wordList.btn_delete_all }}
                        </v-list-item-title>
                      </v-list>
                    </v-menu>
                  </div>
                </div>
              </template>
              <!-- モバイル時のみ全選択チェックボックスを表示（hide-default-headerでデフォルトヘッダーを非表示にしているため） -->
              <template #thead="{ selectAll, allSelected, someSelected }">
                <tr v-if="isXs">
                  <th>
                    <v-checkbox-btn
                        :model-value="allSelected"
                        :indeterminate="someSelected && !allSelected"
                        @update:model-value="selectAll"
                    />
                  </th>
                </tr>
              </template>
              <template #[`item.actions`]="{ item }">
                <div v-if="!$vuetify.display.xs">
                  <v-btn
                    icon
                    variant="outlined"
                    color="primary"
                    class="my-2 ml-2"
                    size="x-small"
                    rounded="circle"
                    @click="onClickEdit(item.memberId)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>

                  <v-btn
                    icon
                    variant="outlined"
                    color="red"
                    class="my-2 ml-2 mr-0"
                    size="x-small"
                    rounded="circle"
                    @click="onClickDelete(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
                <div v-else class="d-flex justify-end mb-3">
                  <v-btn
                    variant="outlined"
                    color="primary"
                    class="my-2 mx-2"
                    @click="onClickEdit(item.memberId)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                    編集</v-btn
                  >
                  <v-btn
                    variant="outlined"
                    color="red"
                    class="my-2 ml-2 mr-0"
                    @click="onClickDelete(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                    削除</v-btn
                  >
                </div>
              </template>
            </v-data-table-server>
          </v-card>
        </v-card>
      </v-card-text>
    </v-card>
    <!-- 会員編集画面 { -->
    <v-card v-if="isWordListReady && editPage && !confirmPage" :flat="true">
      <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
        {{ wordList.lbl_member_edit }}
      </v-card-title>
      <Form
        v-slot="{ meta }"
        :initial-values="editMemberInitialValues"
        :key="editMember?.member_id ?? 'edit-form'"
        validate-on-mount
       
      >
        <v-card-text>
          <v-card :flat="true">
            <v-card-text>
              <!-- 会員番号 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_member_id }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="7" md="7" lg="7" class="text-body-1 d-flex align-center">
                  <Field :name="wordList.lbl_member_id" rules="required" v-slot="{ field }">
                    <input
                      type="hidden"
                      :name="field.name"
                      :value="editMember.member_id"
                    />
                  </Field>
                  {{ editMember.member_id }}
                </v-col>
              </v-row>
              <!-- 住所 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end"
                    >{{ wordList.lbl_delivery_destination_address }}
                    <ImportantChip></ImportantChip
                  ></v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" class="color_black">
                  {{ editMember.zip_code ? "〒" : ""
                  }}{{ editMember.zip_code.substring(0, 3)
                  }}{{ editMember.zip_code ? "-" : ""
                  }}{{ editMember.zip_code.substring(3) }}
                  {{ editMember.address1 }}
                </v-col>
              </v-row>
              <!-- 住所変更ボタン -->
              <v-row class="mt-0">
                <v-col cols="12" sm="4" md="4" lg="4"></v-col>
                <v-col class="pl-2 pt-0"
                  ><v-btn
                    size="small"
                    color="primary"
                    variant="outlined"
                    :disabled="isDisabled"
                    @click="onClickAddressUpdate"
                  >
                    {{ wordList.btn_address_change }}
                  </v-btn>
                </v-col>
              </v-row>
              <!-- 配達先住所(番地) -->
              <v-row>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_destination_address_detail }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_delivery_destination_address_detail"
                    rules="required|max:100"
                  >
                    <v-text-field
                      :model-value="field.value ?? editMember.address2"
                      :placeholder="
                        wordList.plc_delivery_destination_address_detail
                      "
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      :disabled="isDisabled"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          editMember.address2 = val;
                        }
                      "
                      @blur="() => field.onBlur()"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 建物名 部屋番号 -->
              <v-row>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_room_num }}
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_room_num"
                    rules="max:100"
                  >
                    <v-text-field
                      :model-value="field.value ?? editMember.address3"
                      :placeholder="wordList.plc_room_num"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      :disabled="isDisabled"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          editMember.address3 = val;
                        }
                      "
                      @blur="() => field.onBlur()"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- お名前(漢字)-->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_name_kanji }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6" sm="3" md="3" lg="3">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_family_name_kanji"
                    rules="required|min:1|max:100"
                  >
                    <v-text-field
                      :model-value="field.value ?? editMember.name1"
                      :placeholder="wordList.plc_family_name_kanji"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      :disabled="isDisabled"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          editMember.name1 = val;
                        }
                      "
                      @blur="() => field.onBlur()"
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col cols="6" sm="3" md="3" lg="3">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_first_name_kanji"
                    rules="required|min:1|max:100"
                  >
                    <v-text-field
                      :model-value="field.value ?? editMember.name2"
                      :placeholder="wordList.plc_first_name_kanji"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      :disabled="isDisabled"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          editMember.name2 = val;
                        }
                      "
                      @blur="() => field.onBlur()"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- お名前(かな) -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_name_kana }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6" sm="3" md="3" lg="3">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_family_name_kana"
                    rules="required|min:1|max:100|regex:^[ぁ-んー]+$"
                  >
                    <v-text-field
                      :model-value="field.value ?? editMember.name_kana1"
                      :placeholder="wordList.plc_family_name_kana"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      :disabled="isDisabled"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          editMember.name_kana1 = val;
                        }
                      "
                      @blur="() => field.onBlur()"
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col cols="6" sm="3" md="3" lg="3">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_first_name_kana"
                    rules="required|min:1|max:100|regex:^[ぁ-んー]+$"
                  >
                    <v-text-field
                      :model-value="field.value ?? editMember.name_kana2"
                      :placeholder="wordList.plc_first_name_kana"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      :disabled="isDisabled"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          editMember.name_kana2 = val;
                        }
                      "
                      @blur="() => field.onBlur()"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 電話番号 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_tel }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_tel"
                    rules="required|numeric|min:10|max:11"
                  >
                    <v-text-field
                      :model-value="field.value ?? editMember.phone"
                      :placeholder="wordList.plc_tel"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      :disabled="isDisabled"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          editMember.phone = val;
                        }
                      "
                      @blur="() => field.onBlur()"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- ハウスカード番号 -->
              <v-row v-if="house_card_display == 1" dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center"
                    v-if="house_card_required == 1"
                    dense
                      class="form-label-row mr-3 justify-sm-end"
                  >
                    {{ wordList.lbl_house_card }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                  <v-row align="center" v-else dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_house_card }}
                  </v-row>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_house_card"
                    :rules="house_card_validation"
                  >
                    <v-text-field
                      :model-value="field.value ?? editMember.house_card"
                      :placeholder="wordList.plc_house_card"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          editMember.house_card = val;
                        }
                      "
                      @blur="() => field.onBlur()"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- 会員備考 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_memo_member }}
                  </v-row>
                </v-col>
                <v-col cols="12" sm="7" md="7" lg="7">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_memo_member"
                  >
                    <v-textarea
                      :model-value="field.value ?? editMember.notes"
                      :placeholder="wordList.plc_memo_member"
                      variant="outlined"
                      :error-messages="errors"
                      :disabled="isDisabled"
                      @update:model-value="
                        (val) => {
                          field.onChange(val);
                          editMember.notes = val;
                        }
                      "
                      @blur="() => field.onBlur()"
                    >
                    </v-textarea>
                  </Field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-center flex-wrap">
              <!-- 戻るボタン -->
              <v-btn
                variant="flat"
                color="return"
                class="btn_width_1 my-2 mx-2"
                @click="onClickUpdateCancel"
              >
                <v-icon>mdi-arrow-left</v-icon>
                {{ wordList.btn_return }}
              </v-btn>
              <!-- 登録手続きへボタン -->
              <v-btn
                variant="flat"
                color="primary"
                class="btn_width_1 my-2 mx-2"
                :disabled="!meta.valid || !(editMember && editMember.address1)"
                @click="onClickUpdate"
              >
                <v-icon>mdi-playlist-edit</v-icon>
                {{ wordList.btn_regist_confirm }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </Form>
    </v-card>
    <!-- } 会員編集画面 -->
    <!-- 会員更新確認 { -->
    <v-card v-if="isWordListReady && confirmPage" :flat="true">
      <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
        {{ wordList.lbl_member_confirm }}
      </v-card-title>
      <v-card-text class="confirm-display-text">
        <!-- 会員番号 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black"
            ><v-row align="center" dense class="form-label-row mr-3 justify-sm-end"
              >{{ wordList.lbl_member_id }}
              <ImportantChip></ImportantChip> </v-row
          ></v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ editMember.member_id }}
          </v-col>
        </v-row>
        <!-- 配達先住所 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_destination_address }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ editMember.zip_code ? "〒" : ""
            }}{{ editMember.zip_code.substring(0, 3)
            }}{{ editMember.zip_code ? "-" : ""
            }}{{ editMember.zip_code.substring(3) }}
            {{ editMember.address1 }}
          </v-col>
        </v-row>
        <!-- 配達先住所(番地) -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_destination_address_detail }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ editMember.address2 }}
          </v-col>
        </v-row>
        <!-- 建物名 部屋番号 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_room_num }}
            </v-row></v-col
          >
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ editMember.address3 }}
          </v-col>
        </v-row>
        <!-- お名前(漢字) -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_name_kanji }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ editMember.name1 }}{{ editMember.name2 }}
          </v-col>
        </v-row>
        <!-- お名前(かな) -->
        <v-row dense class="mb-3">
          <!-- お名前(かな) -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_name_kana }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1"
            >{{ editMember.name_kana1 }}{{ editMember.name_kana2 }}</v-col
          >
        </v-row>
        <!-- 電話番号 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_tel }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ editMember.phone }}
          </v-col>
        </v-row>
        <!-- ハウスカード番号 -->
        <v-row v-if="house_card_display == 1" dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center"
              v-if="house_card_required == 1"
              dense
                class="form-label-row mr-3 justify-sm-end"
            >
              {{ wordList.lbl_house_card }}
              <ImportantChip></ImportantChip>
            </v-row>
            <v-row align="center" v-else dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_house_card }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ editMember.house_card }}
          </v-col>
        </v-row>
        <!-- 会員備考 -->
        <v-row dense class="mb-3">
          <v-col cols="4" sm="4" md="4" lg="4" class="font-weight-black"
            ><v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_memo_member }}
            </v-row>
          </v-col>
          <v-col cols="8" sm="8" md="8" lg="8" class="text-body-1">
            {{ editMember.notes }}
          </v-col>
          <v-col offset="4" cols="8" class="text-body-1 text-caption">
            {{ messageMemberNotes }}
          </v-col>
        </v-row>
      </v-card-text>
      <!-- 編集処理時のボタン { -->
      <v-card-actions v-if="processFlag < 2" class="justify-center flex-wrap">
        <v-btn
          variant="flat"
          color="primary"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmUpdateOk"
        >
          <v-icon>mdi-playlist-edit</v-icon>
          {{ wordList.btn_member_regist }}</v-btn
        >
        <v-btn
          v-if="deliveryRequestFlag"
          variant="flat"
          color="primary"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmUpdateAndDeliveryRequest"
        >
          <v-icon>mdi-playlist-edit</v-icon>
          {{ wordList.btn_delivery_member_regist }}</v-btn
        >
      </v-card-actions>
      <v-card-actions v-if="processFlag < 2" class="justify-center">
        <v-btn
          variant="flat"
          color="return"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmUpdateCancel"
        >
          <v-icon>mdi-arrow-left</v-icon>
          {{ wordList.btn_return }}
        </v-btn>
      </v-card-actions>
      <!-- } 編集処理時のボタン -->
      <!-- 削除処理時のボタン { -->
      <v-card-actions v-if="processFlag == 2" class="justify-center flex-wrap">
        <v-btn
          variant="flat"
          color="return"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmUpdateCancel"
        >
          <v-icon>mdi-arrow-left</v-icon>
          {{ wordList.btn_return }}
        </v-btn>
        <v-btn
          variant="flat"
          color="primary"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmDeleteOk"
        >
          <v-icon>mdi-playlist-edit</v-icon>
          {{ wordList.btn_delete_complete }}
        </v-btn>
      </v-card-actions>
      <!-- } 削除処理時のボタン -->
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
    <!-- } 会員更新確認 -->
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
    <!-- 削除確認ダイアログ {-->
    <v-dialog
      v-model="confirmDeleteDialog"
      content-class="dialog_width_1"
      :lock-scroll="false"
      scrollable
    >
      <v-data-iterator
        :items="selectListCheckbox"
        item-key="memberId"
        hide-default-footer
        :items-per-page="-1"
      >
        <template #default="{ items }">
          <v-card class="rounded-t rounded-b-0">
            <v-card-title class="bg-red mb-5" style="color: white">
              一括削除内容確認
            </v-card-title>

            <v-card-text class="font-weight-black">
              {{ selectListCheckbox.length }} 件の会員を削除します。
            </v-card-text>

            <v-card-text style="max-height: 60vh; overflow-y: auto;">
              <v-card
                v-for="item in items"
                :key="item.raw.memberId"
                :flat="true"
                variant="outlined"
                class="mb-5"
              >
                <v-card-title>
                  <h4>{{ item.raw.memberId }} : {{ item.raw.name }}</h4>
                </v-card-title>

                <v-divider class="mx-4"></v-divider>

                <v-list density="compact">
                  <v-list-item>
                    <v-row dense>
                      <v-col cols="5" sm="3" class="font-weight-black">
                        <v-row dense class="py-2 justify-end">会員番号:</v-row>
                      </v-col>
                      <v-col cols="7" class="d-flex align-center">
                        {{ item.raw.memberId }}
                      </v-col>
                    </v-row>
                  </v-list-item>

                  <v-list-item>
                    <v-row dense>
                      <v-col cols="5" sm="3" class="font-weight-black">
                        <v-row dense class="py-2 justify-end">お名前:</v-row>
                      </v-col>
                      <v-col cols="7" class="d-flex align-center">
                        {{ item.raw.name }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-card-text>
          </v-card>
        </template>
        <template #footer>
          <v-card :flat="true" class="py-4 rounded-b rounded-t-0">
            <!-- モバイル時はflex-wrapで折り返し -->
            <v-row justify="center" class="flex-wrap">
              <!-- 戻るボタン -->
              <v-btn
                variant="flat"
                color="return"
                class="px-16 mx-2 my-2"
                width="168px"
                @click="confirmDeleteDialog = false"
              >
                <v-icon>mdi-arrow-left</v-icon>
                {{ wordList.btn_return }}</v-btn
              >
              <v-btn
                variant="outlined"
                class="bg-red-darken-1 mx-2 my-2"
                color="white"
                width="168px"
                @click="onClickCheckDeleteComplete"
                >{{ wordList.btn_delete_all }}</v-btn
              >
            </v-row>
          </v-card>
        </template>
      </v-data-iterator>
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>
    <!-- } 削除確認ダイアログ -->
    <AddressSelectorDialog
      :address-dialog="addressDialog"
      :area-dialog="areaDialog"
      :toggle-mode="btnNonMemberToggle"
      :zip-code="zip_code"
      :pref="prefSelectValue"
      :pref-list-items="prefListItems"
      :selected-address="selectedAddressLabel"
      :original-city="originalCityAddress"
      :city-block-list="cityBlockList ?? null"
      :section-block-list="sectionBlockList ?? null"
      :block-list="addressDialogBlockList"
      :click-disabled="clickMode"
      :area-not-select-message="areaNotSelectLabel"
      :errors="addressDialogErrors"
      :word-list="wordList"
      @update:address-dialog="onAddressDialogUpdate"
      @update:area-dialog="onAreaDialogUpdate"
      @update:zip-code="onZipCodeUpdate"
      @update:pref="onPrefUpdate"
      @toggle-zip="onClickToggleZip"
      @toggle-pref="onClickTogglePref"
      @zip-input="onZipCodeInput()"
      @pref-input="onPrefSelectInput"
      @search="onClickDeliveryRequestAndNewMember"
      @close-address="onCloseAddressDialog"
      @area-return="onClickAreaDialogReturn"
      @select-city="onClickCityBlockLink"
      @select-section="onClickSectionBlockLink"
      @select-block="onClickAddressBlockLink"
    />
    <!-- 一覧設定ダイアログ { -->
    <v-dialog
      v-model="displayListSettingDialog"
      persistent
      content-class="dialog_width_2"
      height="100%"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center pb-0">
          <div>一覧設定</div>
          <v-btn
            variant="text"
            icon="mdi-close"
            @click="displayListSettingDialog = false"
          ></v-btn>
        </v-card-title>
        <v-card-text class="py-0">
          <v-container class="pt-2">
            <draggable v-model="tableHeadersSetting" item-key="id" tag="div">
              <template #item="{ element }">
                <v-row
                  class="mt-0 mb-0 pt-0 pb-0"
                  :class="{ br_b_1: $vuetify.display.xs }"
                >
                  <v-col
                    cols="12"
                    class="my-2 pt-0 pb-0 d-flex justify-space-between align-center"
                    :class="{ 'px-0': $vuetify.display.xs }"
                  >
                    <div :class="{ caption: $vuetify.display.xs }">
                      <v-icon>mdi-drag</v-icon>
                      {{ element.settingText }}
                    </div>
                    <div
                      class="d-flex pt-0"
                      :class="{ 'mt-1': $vuetify.display.xs }"
                    >
                      <div class="d-flex align-center">
                        <v-switch
                          v-model="element.display"
                          color="primary"
                          class="mt-0"
                          hide-details
                        ></v-switch>
                        <div class="setting_line"></div>
                      </div>
                      <v-radio-group
                        v-model="element.order"
                        inline
                        class="mt-0 flex-shrink-0"
                        hide-details
                      >
                        <v-radio
                          true-icon="mdi-arrow-up-drop-circle"
                          false-icon="mdi-arrow-up-drop-circle-outline"
                          value="asc"
                          :disabled="element.orderDisabled"
                          class="mr-1"
                          false="color_primary"
                        ></v-radio>
                        <v-radio
                          true-icon="mdi-arrow-down-drop-circle"
                          false-icon="mdi-arrow-down-drop-circle-outline"
                          value="desc"
                          :disabled="element.orderDisabled"
                          class="mr-0"
                          false="color_primary"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                </v-row>
              </template>
            </draggable>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-5 pb-7">
          <v-btn
            class="width_30per"
            variant="outlined"
            @click="onClickListSettingCancel"
            >キャンセル</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="width_30per"
            variant="outlined"
            @click="onClickListSettingReset"
            >リセット</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="width_30per"
            variant="flat"
            color="primary"
            @click="onClickListSettingOk"
            >設定</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- } 一覧設定ダイアログ -->
    <!-- スマホ検索ダイアログ { -->
    <v-dialog
      v-model="displayListSearchDialog"
      fullscreen
      :scrim="false"
      transition="dialog-bottom-transition"
    >
      <Form v-slot="{ meta }">
        <v-card :flat="true">
          <v-card-title class="px-0 py-0">
            <v-toolbar dark color="primary">
              <v-btn
                icon
                color="white"
                @click="displayListSearchDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>絞り込み検索</v-toolbar-title>
              <v-spacer></v-spacer> </v-toolbar
          ></v-card-title>
          <v-card-text
            class="py-0 overflow-auto"
            style="height: calc(100vh - 133px)"
          >
            <v-row>
              <!-- お名前(漢字・かな) -->
              <v-col cols="12" sm="6" md="4" class="mt-10 py-0">
                <Field
                  v-slot="{ field, errors }"
                  :name="wordList.lbl_name_kanji_kana"
                  rules="max:100"
                >
                  <v-text-field
                    :model-value="searchConditionName"
                    :label="wordList.lbl_name_kanji_kana"
                    bg-color="#fff"
                    density="compact"
                    variant="outlined"
                    clearable
                    :error-messages="errors"
                    @update:model-value="
                      (val) => {
                        field.onChange(val);
                        searchConditionName = val;
                      }
                    "
                    @blur="() => field.onBlur()"
                  ></v-text-field>
                </Field>
              </v-col>
              <!-- 電話番号 -->
              <v-col cols="12" sm="6" md="4" class="py-0">
                <Field
                  v-slot="{ field, errors }"
                  :name="wordList.lbl_tel"
                  rules="numeric|max:11"
                >
                  <v-text-field
                    :model-value="searchConditionPhone"
                    :label="wordList.lbl_tel"
                    bg-color="#fff"
                    density="compact"
                    variant="outlined"
                    clearable
                    :error-messages="errors"
                    @update:model-value="
                      (val) => {
                        field.onChange(val);
                        searchConditionPhone = val;
                      }
                    "
                    @blur="() => field.onBlur()"
                  ></v-text-field>
                </Field>
              </v-col>
              <!-- 郵便番号 -->
              <v-col cols="12" sm="6" md="4" class="py-0">
                <Field
                  v-slot="{ field, errors }"
                  :name="wordList.lbl_zipcode"
                  rules="numeric|length:7"
                >
                  <v-text-field
                    :model-value="searchConditionZipCode"
                    :label="wordList.lbl_zipcode"
                    bg-color="#fff"
                    density="compact"
                    variant="outlined"
                    clearable
                    :error-messages="errors"
                    @update:model-value="
                      (val) => {
                        field.onChange(val);
                        searchConditionZipCode = val;
                      }
                    "
                    @blur="() => field.onBlur()"
                  ></v-text-field>
                </Field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              variant="flat"
              color="primary"
              class="px-16 my-3"
              :disabled="!meta.valid"
              @click="onClickSearch"
              ><v-icon>mdi-magnify</v-icon>{{ wordList.lbl_search }}</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </Form>
    </v-dialog>
    <!-- } スマホ検索ダイアログ -->
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useDisplay } from "vuetify";
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import { required, max, min, numeric, regex, length } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import ImportantChip from "@/components/ImportantChip.vue";
import AlertDialog from "@/components/AlertDialog.vue";
import AddressSelectorDialog from "@/components/address-selector/AddressSelectorDialog.vue";
import type {
  AddressBlockItem as SharedAddressBlockItem,
  AddressSelectionErrors,
} from "@/components/address-selector/types";
import draggable from "vuedraggable";

import { useMemberUiState } from "./composables/useMemberUiState";
import { useMemberSearchForm } from "./composables/useMemberSearchForm";
import { useMemberTable } from "./composables/useMemberTable";
import { useMemberActions } from "./composables/useMemberActions";
import { useMemberAddress } from "./composables/useMemberAddress";
import { useMemberInit } from "./composables/useMemberInit";
import { useMemberEditForm } from "./composables/useMemberEditForm";

defineRule("required", required);
defineRule("max", max);
defineRule("min", min);
defineRule("numeric", numeric);
defineRule("regex", regex);
defineRule("length", length);
configure({
  generateMessage: localize({
    ja,
  }),
});
setLocale("ja");

////////////////////////////////////////////////////////////////////////////////
// レスポンシブ対応
////////////////////////////////////////////////////////////////////////////////
const { xs } = useDisplay();
const isXs = computed(() => xs.value);

////////////////////////////////////////////////////////////////////////////////
// 共有ref
////////////////////////////////////////////////////////////////////////////////
const wordList = ref<Record<string, string>>({});
const prefListItems = ref<(string | null | undefined)[]>([]);

////////////////////////////////////////////////////////////////////////////////
// composables セットアップ
////////////////////////////////////////////////////////////////////////////////

// 1. 依存なし composables
const {
  errdialog,
  errMessage,
  editPage,
  confirmPage,
  processFlag,
  confirmDeleteDialog,
  addressDialog,
  areaDialog,
  overlay,
  displayListSettingDialog,
  displayListSearchDialog,
  onClickListSearch,
  openListPage,
  openConfirmDeletePage,
} = useMemberUiState();

const {
  searchConditionName,
  searchConditionPhone,
  searchConditionZipCode,
  searchConditionHouseCard,
} = useMemberSearchForm();

const {
  tableHeadersSetting,
  initTableHeaders,
  filteredTableHeaders,
  getRowProps,
  listLoading,
  listOptions,
  listDataArray,
  listDataTotalCount,
  pageCount,
  selectListCheckbox,
  displayPagingRangeText,
  onClickListSetting: _onClickListSetting,
  onClickListSettingCancel: _onClickListSettingCancel,
  onClickListSettingReset,
  onClickListSettingOk: _onClickListSettingOk,
} = useMemberTable();

// 一覧設定ダイアログ ラッパー（ダイアログ表示制御を追加）
const onClickListSetting = (): void => {
  _onClickListSetting();
  displayListSettingDialog.value = true;
};

const onClickListSettingCancel = (): void => {
  _onClickListSettingCancel();
  displayListSettingDialog.value = false;
};

const onClickListSettingOk = (): void => {
  _onClickListSettingOk();
  displayListSettingDialog.value = false;
};

// 2. アクション（uiState, searchForm, table に依存）
const {
  editMember,
  searchQuery,
  onClickSearch,
  onClickEdit,
  onClickCheckDelete,
  onClickCheckDeleteComplete,
  onClickDelete,
  onClickConfirmDeleteOk,
} = useMemberActions({
  errdialog,
  errMessage,
  editPage,
  confirmPage,
  overlay,
  confirmDeleteDialog,
  openConfirmDeletePage,
  searchConditionName,
  searchConditionPhone,
  searchConditionZipCode,
  searchConditionHouseCard,
  listOptions,
  listDataArray,
  listDataTotalCount,
  listLoading,
  displayPagingRangeText,
  selectListCheckbox,
});

// 3. 住所（uiState, actions に依存）
const {
  panel,
  blockList,
  sectionBlockList,
  zip_code,
  prefSelectValue,
  clickMode,
  btnNonMemberToggle,
  userErrorMessage,
  errorZipCode,
  errorPrefSelect,
  cityBlockList,
  originalAddress,
  originalCityAddress,
  originalSectionAddress,
  onClickToggleZip,
  onClickTogglePref,
  onPrefSelectInput,
  onClickDeliveryRequestAndNewMember,
  onClickCityBlockLink,
  onClickSectionBlockLink,
  onClickAddressBlockLink,
  onClickAddressUpdate,
  onCloseAddressDialog,
  onClickAreaDialogReturn,
  onZipCodeInput,
  areaNotSelectLabel,
} = useMemberAddress({
  errdialog,
  errMessage,
  addressDialog,
  areaDialog,
  editMember,
  wordList,
  prefListItems,
});

// 4. 初期化（uiState, address, table に依存）
const {
  isWordListReady,
  house_card_display,
  house_card_validation,
  house_card_required,
  nowDate,
  isDisabled,
  statusSelectedItem,
} = useMemberInit({
  errdialog,
  errMessage,
  wordList,
  prefSelectValue,
  originalAddress,
  cityBlockList,
  initTableHeaders,
});

// 5. 編集フォーム（uiState, actions, init に依存）
const {
  deliveryRequestFlag,
  messageMemberNotes,
  editMemberInitialValues,
  onClickUpdateCancel,
  onClickUpdate,
  onClickConfirmUpdateCancel,
  onClickConfirmUpdateOk,
  onClickConfirmUpdateAndDeliveryRequest,
} = useMemberEditForm({
  errdialog,
  errMessage,
  editPage,
  confirmPage,
  overlay,
  processFlag,
  editMember,
  openListPage,
  searchQuery,
  wordList,
  isWordListReady,
  listOptions,
  nowDate,
  statusSelectedItem,
});

/** 住所選択ダイアログの選択中住所表示。 */
const selectedAddressLabel = computed(() => {
  return `${prefSelectValue.value}${originalCityAddress.value}${originalSectionAddress.value}`;
});

/** 共通ダイアログ向けに丁目候補を正規化する。 */
const addressDialogBlockList = computed<SharedAddressBlockItem[]>(() => {
  return (blockList.value ?? []).filter(
    (value): value is SharedAddressBlockItem => value !== null && value !== undefined
  );
});

/** 共通ダイアログ向けにエラーを集約する。 */
const addressDialogErrors = computed<AddressSelectionErrors>(() => {
  return {
    zip: errorZipCode.value,
    pref: errorPrefSelect.value,
    general: userErrorMessage.value,
  };
});

/** addressDialog の v-model 更新を反映する。 */
const onAddressDialogUpdate = (value: boolean): void => {
  addressDialog.value = value;
};

/** areaDialog の v-model 更新を反映する。 */
const onAreaDialogUpdate = (value: boolean): void => {
  areaDialog.value = value;
};

/** 郵便番号入力値の更新を反映する。 */
const onZipCodeUpdate = (value: string): void => {
  zip_code.value = value;
};

/** 都道府県入力値の更新を反映する。 */
const onPrefUpdate = (value: string): void => {
  prefSelectValue.value = value;
};
</script>

<style scoped>
/* Vuetify v3のv-expansion-panel-textの内部ラッパースタイル指定 */
:deep(.v-expansion-panel-text__wrapper) {
  padding-top: 0px;
}
/* 一覧設定ダイアログ: v-radio-groupのデフォルトflex-directionを上書きして横並びにする */
:deep(.v-radio-group > .v-input__control) {
  flex-direction: row;
}
</style>
